<div class="Dialog-body">              
  <span >This will clear all entries are you sure?</span>
  <div style="margin-top: 10%;"></div>
  <div class="buttonbelow">         
    <button mat-button (click)="submitFilePreview()"  >Yes</button>
    <button mat-button  (click)="DialogClose()" >No</button>    
  </div>
</div>